export default function initFilterModel () {
  return {
    search : '',
    page: {
      page: 1,
      size: 10
    },
    sort: {
      col: '',
      dir: ''
    },
    statuses: ['ACTIVE'],
    lastLoginStartDate: null,
    lastLoginEndDate: null
  }
}